var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUsersIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 14,
  viewBox: "0 0 16 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.3337 13V11.6667C11.3337 10.9594 11.0527 10.2811 10.5526 9.78105C10.0525 9.28095 9.37424 9 8.66699 9H3.33366C2.62641 9 1.94814 9.28095 1.44804 9.78105C0.947944 10.2811 0.666992 10.9594 0.666992 11.6667V13M15.3337 13V11.6667C15.3332 11.0758 15.1366 10.5018 14.7746 10.0349C14.4126 9.56791 13.9057 9.23438 13.3337 9.08667M10.667 1.08667C11.2406 1.23353 11.749 1.56713 12.1121 2.03487C12.4752 2.50261 12.6722 3.07789 12.6722 3.67C12.6722 4.26211 12.4752 4.83739 12.1121 5.30513C11.749 5.77287 11.2406 6.10647 10.667 6.25333M8.66699 3.66667C8.66699 5.13943 7.47308 6.33333 6.00033 6.33333C4.52757 6.33333 3.33366 5.13943 3.33366 3.66667C3.33366 2.19391 4.52757 1 6.00033 1C7.47308 1 8.66699 2.19391 8.66699 3.66667Z",
  stroke: "#0E1680",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgUsersIcon;